
import { defineComponent, reactive } from 'vue'
import CloserController from '../../molecules/CloserController.vue'
import { store } from '@/store'
import { Content } from '@/data/@types/Content'
import { useRoute, useRouter } from 'vue-router'
import makeUpdatedPidString from '@/domain/item/itemViewer/makeUpdatedPidString'
import { useRouterExtention } from '@/helpers/hooks/useRouterExtention'

export default defineComponent({
  name: 'DirectoryIndexTree',
  components: {
    CloserController,
  },
  props: {
    index: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: 'li'
    },
    n: {
      type: Number,
      default: 1
    },
    hasDirectory: {
      type: Boolean,
      default: false
    },
    pid: {
      type: String,
      required: true
    },
    contentsBundleId: {
      type: Number,
      required: true
    },
    currentFileDirectoryId: {
      type: String,
      required: true
    },
    current: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, context) {
    const route = useRoute()
    const router = useRouter()
    const routerExtention = useRouterExtention(route, router)
    const state = reactive<{ show: boolean }>({
      show: true,
    })

    // ファイルビューアで特定のディレクトリを表示させる
    const changeDirectory = (directoryId: string) => {
      if (Number(route.params.bundleIndex) !== props.contentsBundleId) {
        routerExtention.replaceOrPush('/' + makeUpdatedPidString(props.pid) + '/' + (props.contentsBundleId + 1))
        updateViewer()
      }
      store.commit('changeFileViewerDirectory', directoryId)
    }

    const getContentIndex = (contentId: string) => {
      const contents: Array<Content> = store.getters.contents
      return contents.findIndex(v => v.id === contentId)
    }

    const updateViewer = () => {
      context.emit('updateViewer', props.contentsBundleId)
    }

    const changeSelectContent = (path: string) => {
      routerExtention.replaceOrPush(path)
      updateViewer()
    }

    const generatePath = (pid: string, contentsBundleIndex: string, indexId: string) =>
      '/' + makeUpdatedPidString(pid) + '/' + (Number(contentsBundleIndex) + 1) + '/' + (getContentIndex(indexId) + 1)

    return {
      state,
      changeDirectory,
      updateViewer,
      changeSelectContent,
      generatePath,
    }
  }
})
